import { TipTapReactNodeViewRenderer } from '@lessonup/pin-renderer';
import { fillInTheBlanksBaseExtensionConfig } from '@lessonup/pins-shared';
import { Node as TiptapNode } from '@tiptap/core';
import { EditorState, Transaction } from '@tiptap/pm/state';
import { FillInTheBlanksWordNode } from './FillInTheBlanksWordNode';

export const fillIntheBlanksEditorExtension = TiptapNode.create({
  ...fillInTheBlanksBaseExtensionConfig,
  addNodeView: () => {
    return TipTapReactNodeViewRenderer(FillInTheBlanksWordNode);
  },
  addKeyboardShortcuts() {
    return {
      Delete: () => {
        const { state, dispatch } = this.editor.view;
        return handleBackspaceAndDelete(state, dispatch);
      },
      Backspace: () => {
        const { state, dispatch } = this.editor.view;
        return handleBackspaceAndDelete(state, dispatch);
      },
    };
  },
});

/**
 * Handle backspace and delete for fill in the blanks nodes
 * Goal is to make sure there are no empty nodes left in the document after the operation
 *
 * I am not sure about this code and very open to suggestions
 */
function handleBackspaceAndDelete(state: EditorState, dispatch: (tr: Transaction) => void) {
  const { $from, $to } = state.selection;
  // Check if cursor is on a blank
  const node = $from.node($from.depth);
  const currentNodeType = node.type.name;
  if (currentNodeType !== fillInTheBlanksBaseExtensionConfig.name) return false;
  const nodeText = node.textContent;

  let shouldDelete = false;
  // the last character delete does not show up as a transaction, so we need to handle it separately
  if (nodeText.length === 1) {
    shouldDelete = true;
  }

  const selectionSize = $to.pos - $from.pos;
  // If you double click the content the selection is one character off
  if (node.content.size + 1 === selectionSize || node.content.size === selectionSize) {
    const selectedText = state.doc.textBetween($from.pos, $to.pos, '\n');
    // extra check to make sure we are not deleting the wrong thing
    if (selectedText === nodeText) {
      shouldDelete = true;
    }
  }

  if (shouldDelete) {
    const nodePos = $from.before();
    const tr = state.tr;
    tr.delete(nodePos, nodePos + node.nodeSize);
    dispatch(tr);
    return true;
  }

  return false;
}
